<template>
  <v-app>
    <!-- <v-app-bar
      app
      color="white"
      elevate-on-scroll
    >
      <div class="d-flex align-center">
        <v-img
          alt="FiXpert Logo"
          contain
          :src="require('@/assets/logo.png')"
          transition="scale-transition"
          width="90"
        />
      </div>

      <v-spacer></v-spacer>

      <v-app-bar-nav-icon></v-app-bar-nav-icon>
    </v-app-bar>-->
    <v-app-bar app class="mx-auto elevation-0" fixed style="max-width:1280px">
      <v-img
        alt="FiXpert Logo"
        contain
        :src="$vuetify.theme.dark ? require('@/assets/logo-dark.png') : require('@/assets/logo.png')"
        width="90"
        max-height="90"
        max-width="80"
        class="mx-2"
        transition="slide-x-transition"
        app
        @click="$router.push('search')"
      />
      <v-spacer></v-spacer>
      <v-chip
        pill
        color="transparent"
        @click="showServicePage"
      >
        <span>Welcome, <strong>{{name}}</strong></span>
        <v-avatar right v-if="image">
          <v-img
            :src="this.$http.defaults.baseURL + image"
            :lazy-src="this.$http.defaults.baseURL + lazyImage"
          ></v-img>
          <!-- <v-img src="https://cdn.vuetifyjs.com/images/lists/1.jpg"></v-img> -->
        </v-avatar>
      </v-chip>
      <v-spacer></v-spacer>
      <v-btn icon class="d-none d-sm-flex" to="/search">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon class="d-none d-sm-flex" color="red" to="/favorites">
        <v-icon>mdi-heart</v-icon>
      </v-btn>
      <v-btn icon @click.stop="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
        v-model="drawer"
        fixed
        right
        app
        @transitionend="fix"
      >
      <v-list-item>
        <div class="caption">Enable/Disable Dark Mode</div>
        <v-spacer></v-spacer>
        <v-switch
          @change="switchTheme"
          x-large
          color="success"
          v-model="$vuetify.theme.dark"
          hide-details
          class="mt-0 pt-0"
        ></v-switch>
      </v-list-item>

      <v-divider></v-divider>

      <div class="d-flex align-center justify-space-between flex-column" style="height:calc(100% - 57px)">
        <div style="width:100%">
          <v-btn text block large to="/search">Search</v-btn>
          <v-btn v-if="!guestMode" text block large to="/favorites">Favorites</v-btn>
          <v-btn text block large to="/edit" v-if="!guestMode && isService">Edit profile</v-btn>
          <v-btn text block large to="/edit-s" v-if="!guestMode && !isService">Edit profile</v-btn>
          <v-btn v-if="!guestMode" text block large to="/area">Edit location</v-btn>
          <v-btn text block large to="/legal">Legal & privacy</v-btn>
          <v-btn v-if="!guestMode" text block large @click="deleteProfile">Delete profile</v-btn>
          <v-btn text block large @click="showHelp">Help</v-btn>
        </div>
        <div v-if="!guestMode" style="width:100%">
          <v-btn text block large to="/switch" v-if="!isService" class="v-btn--multiline font-weight-bold" color="green">
            Register as <br>Service Provider
          </v-btn>
        </div>
        <div v-if="guestMode" style="width:100%">
          <v-btn text block large @click="logout" class="v-btn--multiline font-weight-bold" color="green">
            Register
          </v-btn>
        </div>
        <div style="width:100%" class="pa-5">
          <v-btn @click="logout" text block color="red">Logout</v-btn>
        </div>
      </div>

      <!-- <v-list-item>
        <v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>John Leider</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>

        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list> -->
      <!-- <template v-slot:append>
        <div class="pa-5">
          <v-btn @click="logout" text block color="error">Logout</v-btn>
        </div>
      </template> -->
    </v-navigation-drawer>
    <v-dialog
      v-model="photoViewer"
      transition="scroll-y-transition"
      overlay-opacity="0.8"
      content-class="no-margin"
    >
      <v-row class="fill-height ma-0">
        <v-img
          :src="this.$http.defaults.baseURL + image"
          :lazy-src="this.$http.defaults.baseURL + lazyImage"
        >
          <v-btn
            fab
            absolute
            right
            top
            color="green"
            dark
            small
            class="mt-9"
            @click="photoViewer = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-img>
      </v-row>
    </v-dialog>
    <v-main>
      <v-fab-transition>
        <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          right
          color="green"
          @click="toTop"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
      </v-fab-transition>
      <!-- <v-container class="pa-0" style="max-width:1000px;"> -->
        <!-- <v-divider></v-divider> -->
      <transition name="fade">
        <router-view></router-view>
      </transition>
      <InstallPopup/>
      <v-bottom-sheet v-model="sheet">
        <v-sheet class="text-center" height="250px">
          <v-btn
            class="mt-6"
            outlined
            color="green"
            @click="sheet = !sheet"
          >Cancel</v-btn>
          <div class="py-3">Are you sure you want to delete your profile? <br>All your stored information will be deleted and you will no longer appear in searches.</div>
          <v-btn
            class="mt-6"
            text
            color="red"
            @click="deleteAnyway"
          >Delete anyway</v-btn>
        </v-sheet>
      </v-bottom-sheet>
      <v-dialog v-model="help" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="green" dense class="elevation-0">
            <!-- <v-btn icon dark @click="help = false">
              <v-icon>mdi-close</v-icon>
            </v-btn> -->
            <v-toolbar-title>Help</v-toolbar-title>
          </v-toolbar>
          <v-list three-line subheader>
            <v-subheader>Need Help?</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Call us on:</v-list-item-title>
                <v-list-item-subtitle><v-btn dark color="green" :href="variables['HELP_PHONE_LINK']"><v-icon left>mdi-phone</v-icon> {{ variables['HELP_PHONE_TEXT'] }}</v-btn></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Send us a message:</v-list-item-title>
                <v-list-item-subtitle><v-btn dark color="green" href="mailto:support@fixpert.net"><v-icon left>mdi-email</v-icon> support@fixpert.net</v-btn></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <InquiryForm/>
        </v-card>
        <v-footer
          fixed
          class="pa-0"
          style="z-index:999"
        >
          <v-btn
            block
            tile
            large
            dark
            color="green"
            @click="help = false"
          >
            Close
          </v-btn>
        </v-footer>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import InstallPopup from '@/components/InstallPopup'
import InquiryForm from '@/components/InquiryForm'
import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',
  components: {
    InstallPopup,
    InquiryForm
  },
  data () {
    return {
      photoViewer: false,
      drawer: null,
      sheet: false,
      fab: false,
      help: false
    }
  },
  computed: {
    ...mapGetters(['id', 'image', 'lazyImage', 'name', 'isService', 'area', 'variables', 'guestMode'])
  },
  async mounted () {
    if (!this.guestMode) {
      await this.$store.dispatch('getProfile')
    }

    const area = localStorage.getItem('area')
    if (this.guestMode && area) {
      this.$store.commit('updateSelectedArea', JSON.parse(area))
      return
    }

    if (!this.area) {
      this.$router.push('area')
    }
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    showHelp () {
      this.drawer = false
      this.help = true
    },
    emailReady () {
      this.$refs.text.focus()
    },
    showServicePage () {
      if (this.isService) {
        this.$router.push(`/service/${this.id}`)
      }
    },
    deleteProfile () {
      this.drawer = false
      this.sheet = true
    },
    async deleteAnyway () {
      try {
        await this.$store.dispatch('deleteAccount')
        this.$router.push('/')
      } catch (e) {
        console.log(e)
      }
    },
    fix () {
      const elements = document.getElementsByClassName('v-overlay__scrim')
      for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', () => {
          this.drawer = null
        }, false)
      }
    },
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('/')
    },
    switchTheme (value) {
      this.$vuetify.theme.dark = value
      localStorage.setItem('dark', value)
    }
  }
}
</script>

<style>
  .v-btn--multiline > .v-btn__content {
    display: block;
    text-align: center;
  }

  .v-btn--multiline {
    white-space: normal;
  }
</style>
